module.exports = __webpack_public_path__ + "static/965148388.047e993f.jpg";